'use strict';

var cov_23ebfbl6ka = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/nl2br.filter.js',
        hash = 'ae284cf27bd67ff219744385674233628138211b',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/nl2br.filter.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 16,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 32
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 13,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 16
                },
                end: {
                    line: 12,
                    column: 52
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 16,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'nl2br',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 21
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 14,
                        column: 9
                    }
                },
                line: 10
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_23ebfbl6ka.s[0]++;
(function () {
    'use strict';

    cov_23ebfbl6ka.f[0]++;
    cov_23ebfbl6ka.s[1]++;
    angular.module('app').filter('nl2br', nl2br);

    /* @ngInject */
    function nl2br() {
        cov_23ebfbl6ka.f[1]++;
        cov_23ebfbl6ka.s[2]++;

        return function (input) {
            cov_23ebfbl6ka.f[2]++;
            cov_23ebfbl6ka.s[3]++;

            if (input) {
                cov_23ebfbl6ka.b[0][0]++;
                cov_23ebfbl6ka.s[4]++;

                return input.replace(/\n/g, '<br>');
            } else {
                cov_23ebfbl6ka.b[0][1]++;
            }
        };
    }
})();